import React from 'react';
import clsx from 'classnames';
import './index.css';

const Customer = () => {
  const totalCustomer = [
    {
      id: '1',
      img: '/images/customer1.png',
    },
    {
      id: '2',
      img: '/images/customer2.png',
    },
    {
      id: '3',
      img: '/images/customer3.png',
    },
    {
      id: '4',
      img: '/images/customer4.png',
    },
    {
      id: '5',
      img: '/images/customer5.png',
    },
    {
      id: '6',
      img: '/images/customer6.png',
    },
    {
      id: '7',
      img: '/images/customer7.png',
    },
    {
      id: '8',
      img: '/images/customer8.png',
    },
    {
      id: '9',
      img: '/images/customer9.png',
      isSpecial: true,
    },
    {
      id: '10',
      img: '/images/customer10.png',
    },
    {
      id: '11',
      img: '/images/customer11.png',
    },
  ];
  const topCustomer = totalCustomer.slice(0, 6);
  const bottomCustomer = totalCustomer.slice(6, 11);
  return (
    <div className={clsx('certificate-customer')}>
      <div className={clsx('certificate-customer-title')}>合作客户</div>
      <div className={clsx('certificate-customer-list')}>
        <div className={clsx('certificate-customer-list-top')}>
          {topCustomer.map((item) => (
            <div
              className={clsx('certificate-customer-list-top-item')}
              key={item.id}
            >
              <img src={item.img} alt='' width='70%' height='50%' />
            </div>
          ))}
        </div>
        <div className={clsx('certificate-customer-list-bottom')}>
          {bottomCustomer.map((item) => {
            return (
              <div
                className={clsx('certificate-customer-list-top-item')}
                key={item.id}
              >
                <img
                  src={item.img}
                  alt=''
                  width={item?.isSpecial ? '30%' : '70%'}
                  height='50%'
                />
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default Customer;
